<app-periodo-dashboard [periodoInicial]="periodoInicial" prefijo="periodo-denuncia" (cambio)="onPeriodo($event)">
  <div meta class="tickets-toolbar__meta">
    <span>{{ totalDenuncias }} denuncias</span>
    <strong>{{ etiquetaPeriodo }}</strong>
  </div>
</app-periodo-dashboard>

<div class="tickets-alert" *ngIf="errorCarga">
  {{ errorCarga }}
</div>

<section class="tickets-kpis tickets-kpis--incidents" aria-label="Indicadores principales de denuncias">
  <article class="ticket-kpi" *ngFor="let kpi of kpis" [ngClass]="kpi.className">
    <div class="ticket-kpi__icon">
      <mat-icon>{{ kpi.icon }}</mat-icon>
    </div>
    <div>
      <span>{{ kpi.label }}</span>
      <strong>{{ kpi.value }}</strong>
      <small>{{ kpi.meta }}</small>
    </div>
  </article>

  <div class="tickets-loading-card" *ngIf="cargando && kpis.length === 0">
    Actualizando indicadores...
  </div>
</section>

<section class="tickets-grid">
  <article class="tickets-card tickets-card--status">
    <div class="tickets-card__header">
      <div>
        <span>Canal de denuncias</span>
        <h2>Distribucion por estatus</h2>
      </div>
    </div>

    <div class="tickets-status">
      <div class="tickets-donut" [ngStyle]="getDonutStyle()">
        <div class="tickets-donut__center">
          <strong>{{ totalDenuncias }}</strong>
          <span>Total</span>
        </div>
      </div>

      <div class="tickets-status__legend">
        <div class="tickets-status__item" *ngFor="let item of estatusItems">
          <span class="tickets-status__dot" [style.background]="item.color"></span>
          <span>{{ item.nombre }}</span>
          <strong>{{ item.valor }}</strong>
        </div>
      </div>
    </div>

    <div class="tickets-empty" *ngIf="!cargando && totalDenuncias === 0">
      No hay denuncias para el periodo seleccionado.
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Categorias</span>
        <h2>Mayor concentracion</h2>
      </div>
    </div>

    <div class="tickets-bars" *ngIf="categoriaItems.length > 0; else emptyCategoriasTpl">
      <div class="tickets-bar" *ngFor="let item of categoriaItems; let i = index">
        <div class="tickets-bar__row">
          <span>{{ item.nombre || 'Sin clasificar' }}</span>
          <strong>{{ getBarPercent(item) }}%</strong>
        </div>
        <div class="tickets-bar__track">
          <span [ngStyle]="getBarStyle(item, i)"></span>
        </div>
        <small>{{ item.valor }} denuncias</small>
      </div>
    </div>
  </article>
</section>

<section class="tickets-grid tickets-grid--secondary">
  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Tendencia</span>
        <h2>Recibidas por mes</h2>
      </div>
    </div>

    <div class="incident-months" *ngIf="mesItems.length > 0; else emptyMesesTpl">
      <div class="incident-month" *ngFor="let item of mesItems; let i = index">
        <span>{{ item.nombre }}</span>
        <div class="incident-month__bar">
          <span [ngStyle]="getBarStyle(item, i, mesMax)"></span>
        </div>
        <strong>{{ item.valor }}</strong>
      </div>
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Lectura rapida</span>
        <h2>Atencion pendiente</h2>
      </div>
    </div>

    <div class="incident-summary">
      <div>
        <strong>{{ sinAsignar }}</strong>
        <span>Denuncias recibidas que todavia no tienen responsable asignado (foto actual).</span>
      </div>
      <div>
        <strong>{{ sinAtender }}</strong>
        <span>Recibidas con mas de {{ diasSinAtender }} dias sin cambiar de estatus (foto actual).</span>
      </div>
      <div>
        <strong>{{ anonimas }} / {{ confidenciales }}</strong>
        <span>Anonimas / confidenciales recibidas en el periodo.</span>
      </div>
    </div>
  </article>
</section>

<section class="tickets-card tickets-card--table">
  <div class="tickets-card__header">
    <div>
      <span>Actividad reciente</span>
      <h2>Denuncias recientes</h2>
    </div>
    <button type="button" class="tickets-link-button" *ngIf="rutaVerTodos" (click)="abrirDenuncias()">Ver todos</button>
  </div>

  <div class="tickets-table-wrap" *ngIf="denunciasRecientes.length > 0; else emptyDenunciasTpl">
    <table class="tickets-table">
      <thead>
        <tr>
          <th>Codigo</th>
          <th>Fecha</th>
          <th>Categoria</th>
          <th>Estatus</th>
          <th>Tipo</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let denuncia of denunciasRecientes">
          <td class="tickets-table__id">{{ denuncia.codigoSeguimiento }}</td>
          <td>{{ denuncia.fechaRegistro | date:'dd/MM/yyyy' }}</td>
          <td>{{ denuncia.nombreCategoria || 'Sin categoria' }}</td>
          <td>
            <span class="ticket-status" [ngClass]="getEstatusClass(denuncia)">
              {{ getEstatusLabel(denuncia) }}
            </span>
          </td>
          <td>{{ getTipoLabel(denuncia) }}</td>
          <td>
            <button type="button" class="tickets-table__action" (click)="abrirDenuncia(denuncia)" aria-label="Abrir denuncia">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<ng-template #emptyCategoriasTpl>
  <div class="tickets-empty">No hay distribucion por categoria para el periodo.</div>
</ng-template>

<ng-template #emptyMesesTpl>
  <div class="tickets-empty">No hay tendencia mensual para el periodo.</div>
</ng-template>

<ng-template #emptyDenunciasTpl>
  <div class="tickets-empty">No hay denuncias recientes para mostrar.</div>
</ng-template>
